<template>
<div>
    <div class="container">
        <el-page-header class="page-header" @back="goBack" content="处方信息"></el-page-header>
        <img v-show="hasPaySuccess" src="../../../static/image/ic_pay_success.png"/>
        <span v-show="hasPaySuccess" class="pay-success">支付成功</span>
        <AreaHeader class="area-header-one" title="基本信息"></AreaHeader>
        <ul class="basic-info" v-if="consultInfo">
            <li><b>姓名：</b>{{consultInfo.name}}</li>
            <li><b>性别：</b>{{consultInfo.sex == '1'?'男':'女'}}</li>
            <li><b>电话：</b>{{consultInfo.phoneNo}}</li>
            <li><b>出生日期：</b>{{consultInfo.birthday}}</li>
            <li><b>常住地址：</b>{{consultInfo.liveArea}}</li>
            <li><b>出生地址：</b>{{consultInfo.birthArea}}</li>
            <li v-if="consultInfo.useDate"><b>开始服药时间：</b>{{consultInfo.useDate}}</li>
            <li v-if="consultInfo.useDays"><b>服药天数：</b>{{consultInfo.useDays}}</li>
        </ul>
        <AreaHeader class="area-header" title="症状信息"></AreaHeader>
        <table class="basic-info basic-table">
            <tr class="table-rows" v-for="(item,index) in basicTableArray">
                <td v-if="index == 0" :rowspan="basicTableArray.length">基本情况</td>
                <td v-if="item.value.length > 0">{{item.key}}</td>
                <td v-if="item.value.length > 0">{{item.value}}</td>
            </tr>
            <tr class="table-rows" v-for="(item1,index) in shangjiaoTableArray" v-if="hasShangJiao">
                <td v-if="index == 0" :rowspan="shangjiaoTableArray.length">上焦</td>
                <td v-if="item1.value">{{item1.key}}</td>
                <td v-if="item1.value">{{item1.value.toString()}}</td>
            </tr>
            <tr class="table-rows" v-for="(item2,index) in zhongjiaoTableArray" v-if="hasZhongJiao">
                <td v-if="index == 0" :rowspan="zhongjiaoTableArray.length">中焦</td>
                <td v-if="item2.value">{{item2.key}}</td>
                <td v-if="item2.value">{{item2.value.toString()}}</td>
            </tr>
            <tr class="table-rows" v-for="(item3,index) in xiajiaoTableArray" v-if="hasXiaJiao">
                <td v-if="index == 0" :rowspan="xiajiaoTableArray.length">下焦</td>
                <td v-if="item3.value">{{item3.key}}</td>
                <td v-if="item3.value">{{item3.value.toString()}}</td>
            </tr>
        </table>
        <!-- <div class="header-container">
            <img src="../../../static/image/ic_area_header.png"/>
            <span class="title">开方信息</span>
            <el-button class="btn-info" type="success" @click="serviceInfo('2')">茶饮信息</el-button>
            <el-button class="btn-info" type="success" @click="serviceInfo('3')">经络调理信息</el-button>
            <el-button class="btn-info" type="success" @click="serviceInfo('4')">针灸信息</el-button>
            <el-button class="btn-info" type="success" @click="serviceInfo('5')">中成药信息</el-button>
        </div> -->
        <!-- <el-tabs type="border-card" v-model="tab_name">
          <el-tab-pane name="0" label="开方信息"></el-tab-pane>
          <el-tab-pane name="1" label="茶饮信息">茶饮信息</el-tab-pane>
          <el-tab-pane name="2" label="经络调理信息">经络调理信息</el-tab-pane>
          <el-tab-pane name="3" label="针灸信息">针灸信息</el-tab-pane>
          <el-tab-pane name="4" label="中成药信息">中成药信息</el-tab-pane>
        </el-tabs> -->
        <div style="background-color: #f5f5f5;border-radius: 2px;padding: 10px;">
          <el-radio-group v-model="tab_name">
            <el-radio-button label="0">开方信息</el-radio-button>
            <el-radio-button label="1">茶饮信息</el-radio-button>
            <el-radio-button label="2">经络调理信息</el-radio-button>
            <el-radio-button label="3">针灸信息</el-radio-button>
            <el-radio-button label="4">压片糖果信息</el-radio-button>
          </el-radio-group>
          <div class="other_info_container" v-show="tab_name==1">
            <div class="content">
              <span style="padding-top: 100px;padding-bottom: 100px;text-align: center;width: 100%;" v-show="t_results.length == 0">没有查询到患者茶饮信息</span>
              <p v-for="item in t_results">{{item}}</p>
            </div>
          </div>
          <div class="other_info_container" v-show="tab_name==2">
            <div class="content">
              <span style="padding-top: 100px;padding-bottom: 100px;text-align: center;width: 100%;" v-show="t_results.length == 0">没有查询到患者经络调理信息</span>
              <p v-for="item in m_results">{{item}}</p>
            </div>
          </div>
          <div class="other_info_container" v-show="tab_name==3">
            <div class="content">
              <span style="padding-top: 100px;padding-bottom: 100px;text-align: center;width: 100%;" v-show="t_results.length == 0">没有查询到患者针灸信息</span>
              <p v-for="item in a_results">{{item}}</p>
            </div>
          </div>
          <div class="other_info_container" v-show="tab_name==4">
            <div class="content">
              <span style="padding-top: 100px;padding-bottom: 100px;text-align: center;width: 100%;" v-show="t_results.length == 0">没有查询到患者压片糖果信息</span>
              <p v-for="item in c_results">{{item}}</p>
            </div>
          </div>
          <el-tabs class="tabs" v-model="tabActive" type="border-card" v-if="tablePrescription.length>0 && tab_name==0">
              <el-tab-pane class="tab-pane" :label="pane.title" :name="index.toString()" v-for="(pane,index) in tablePrescription" :key="pane.index">
                  <table border="1" style="margin-left: 3%;width: 94%;margin-right: 3%;">
                      <tr class="table-header">
                          <td>序号</td>
                          <td>药品</td>
                          <td>重量（克）</td>
                          <td>序号</td>
                          <td>药品</td>
                          <td>重量（克）</td>
                      </tr>
                      <tr class="table-rows" v-for="item in pane.options">
                          <td style="width: 8%;">
                            <span class="span-index" v-show="item.key">{{item.index}}</span>
                          </td>
                          <td style="width: 30%;">
                            <div class="item-row" v-show="item.key">
                              <span style="width: 100%; padding-left: 10%; text-align: left;">{{item.key}}</span>
                              <el-button @click="drugChangeClick(pane,item,0)" style="width: 62px;height:30px; border-color: #156098;color: #156098;" size="small" v-if="pane.modifyFlag == 'Y'">更换</el-button>
                            </div>
                          </td>
                          <td style="width: 12%;">
                            <div class="item-row" v-show="item.key">
                              <span style="width: 100%; text-align: center;">{{item.value}}g</span>
                              <el-button  @click="drugWeightClick(pane,item,0)" style="width: 62px;height:30px; border-color: #156098;color: #156098;" size="small" v-if="pane.modifyFlag == 'Y'">更换</el-button>
                            </div>
                          <td style="width: 8%;"><span v-show="item.key1" class="span-index">{{item.index1}}</span></td>
                          <td style="width: 30%;">
                            <div class="item-row" v-show="item.key1">
                              <span style="width: 100%; padding-left: 10%; text-align: left;">{{item.key1}}</span>
                              <el-button @click="drugChangeClick(pane,item,1)" style="width: 25%;height:30px; border-color: #156098;color: #156098;" size="small" v-if="pane.modifyFlag == 'Y'">更换</el-button>
                            </div>
                          </td>
                          <td style="width: 12%;">
                            <div class="item-row" v-show="item.key1">
                              <span style="width: 100%; text-align: center;">{{item.value1}}g</span>
                              <el-button @click="drugWeightClick(pane,item,1)" style="width: 62px;height:30px; border-color: #156098;color: #156098;" size="small" v-if="pane.modifyFlag == 'Y'">更换</el-button>
                            </div>
                          </td>
                      </tr>
                      <tr>
                          <td class="table-footer-td" style="color: red; font-weight: 600;" colspan="6"><b>*</b>请在专业医生指导下服药。</td>
                      </tr>
                      <tr>
                          <td class="table-footer-td" colspan="6"><b>*</b>总计：<b>{{pane.count}}</b>味，<b>{{pane.totalWeight}}</b>克；<b v-show="pane.charge != 0" style="color: black;">参考药价：</b><b v-show="pane.charge != 0">{{pane.charge}}</b><b v-show="pane.charge != 0" style="color: black;">元/副</b></td>
                      </tr>
                      <tr class="table-footer" >
                          <td class="table-footer-td" colspan="6"><b>*</b>有效使用期：{{pane.startDate}} ~ {{pane.endDate}}</td>
                      </tr>
                      <tr class="table-button" v-show="pane.checkStatus == '0' && pane.checkEnable">
                        <td class="table-footer-td" colspan="6">
                          <el-button class="btn-check" type="success" @click="checkConfirm(pane)" :disabled="!pane.checkEnable">提交互联网医院审核</el-button>
                        </td>
                      </tr>
                      <tr class="table-button" v-show="pane.checkStatus != '0'">
                        <td class="table-footer-td" colspan="6">订单审核状态：<b :style="{ color: getTextColor(pane.checkStatus) }">{{pane.checkStatusText}}</b><span style="margin-left: 40px;" v-if="pane.checkCountDown">审核时长：{{pane.checkCountDown}}</span><span style="margin-left: 40px;" v-if="pane.reason && pane.checkStatus == '3'">失败原因：{{pane.reason}}</span></td>
                      </tr>
                      <!-- <tr class="table-footer" v-show="pane.checkImageUrl">
                          <td class="table-footer-td" colspan="6"><b></b>处方图片链接：{{pane.checkImageUrl}}</td>
                      </tr> -->
                      <tr class="table-footer" v-show="pane.checkEnable">
                          <td class="table-footer-td" colspan="6"><b>*</b>{{pane.checkTips}}</td>
                      </tr>
                  </table>
              </el-tab-pane>
              <el-button class="btn-confirm" type="primary" @click="submit">生成处方</el-button>
          </el-tabs>
        </div>
    </div>
    <el-dialog title="选择处方生成类型" :visible.sync="prescriptionStyleVisible" center width="460px" custom-class="prescription-style-dialog">
      <p class="prescription-style-tip">请选择处方版式，生成后可预览和打印。</p>
      <div class="prescription-style-actions">
        <el-button type="primary" plain @click="generatePrescription(0)">生成处方（横版）</el-button>
        <el-button type="primary" plain @click="generatePrescription(1)">生成处方（竖版）</el-button>
      </div>
    </el-dialog>
    <el-dialog title="更换药方" :visible.sync="dialogDrugVisible" center destroy-on-close width="20%">
      <div class="item-column">
        <el-radio class="radio" v-for="drug in changeDrugList" v-model="currentDrug" :label="drug" :key='drug'>{{drug}}</el-radio>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button @click="dialogDrugVisible = false" size="medium">取 消</el-button>
          <el-button type="primary" @click="dialogConfirm" size="medium">修 改</el-button>
        </div>
    </el-dialog>
    <el-dialog title="更换重量" :visible.sync="dialogWeightVisible" center destroy-on-close width="20%">
      <div class="item-row">
        <span style="width: 30%;">{{flag == 0?currentItem.key:currentItem.key1}}</span>
        <el-input-number v-model="currentWeight" @change="numberChange" :min="1" :max="999" :label="flag == 0?currentItem.key:currentItem.key1" size="small"></el-input-number>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button @click="dialogWeightVisible = false" size="medium">取 消</el-button>
          <el-button type="primary" @click="dialogWeightConfirm" size="medium">修 改</el-button>
        </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="checkDialogVisible"
       center destroy-on-close
      width="30%">
      <p style="font-size: 20px;font-weight: bold;text-align: center;width: 100%;">请确认提交内容再提交支付。</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="checkDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="check">确 定</el-button>
      </span>
    </el-dialog>
</div>
</template>

<script>
import AreaHeader from '@/components/widgets/area-header.vue'
import WJTRadio from '@/components/widgets/wjt-radio.vue'
export default {
    components:{
        AreaHeader,
        WJTRadio
    },
    data(){
        return{
            tabActive:'0',
            prescriptions:[],
            tablePrescription:[],
            changeDrugList:[],
            visible:false,
            dialogDrugVisible:false,
            dialogWeightVisible:false,
            prescriptionStyleVisible:false,
            currentDrug:'',
            currentWeight:'',
            currentItem:{},
            flag:0,
            basicTableArray:[],
            shangjiaoTableArray:[],
            zhongjiaoTableArray:[],
            xiajiaoTableArray:[],
            consultInfo:{},
            hasShangJiao:false,
            hasZhongJiao:false,
            hasXiaJiao:false,
            tab_name:0,
            t_results:[],
            m_results:[],
            a_results:[],
            c_results:[],
            checkDialogVisible:false,
            hasPaySuccess:false
        }
    },
    created(){
        this.visitRecordId = this.$route.query.visitRecordId
        this.patientId = this.$route.query.patientId
        var hasPaySuccess = this.$route.query.hasPaySuccess
        if(hasPaySuccess == '1'){
          this.hasPaySuccess = true
        }else{
          this.hasPaySuccess = false
        }
        this.getPrescriptionDetails()
        var activeName = sessionStorage.getItem("checkActiveName")
        if(activeName){
          this.tabActive = activeName;
          var activeName = sessionStorage.setItem("checkActiveName","0")
        }
    },
    methods:{
        goBack(){
            this.$router.go(-1)
        },
        getPrescriptionDetails(){
          this.wjtHttp.post(this,'/api/health/v2/prescription',{visitRecordId:this.visitRecordId},true,(res)=>{
              var data = res.data
              if(data.code == 200){
                  this.prescriptions = data.data.prescriptionInfos
                  this.consultInfo = data.data.patient
                  this.consultInfo.useDate = data.data.startDate
                  this.consultInfo.useDays = data.data.takeDays
                  this.basicTableArray = this.basicTableArray.concat(data.data.inquiryInfo.basic_array)
                  this.basicTableArray = this.basicTableArray.concat(data.data.inquiryInfo.basic_enter_array)
                  this.basicTableArray = this.basicTableArray.concat(data.data.inquiryInfo.maixiang_array)
                  this.shangjiaoTableArray = data.data.inquiryInfo.shangjiao_array
                  this.zhongjiaoTableArray = data.data.inquiryInfo.zhongjiao_array
                  this.xiajiaoTableArray = data.data.inquiryInfo.xiajiao_array
                  var that = this
                  this.shangjiaoTableArray.forEach(function (element) {
                      if(element.value.length > 0){
                        that.hasShangJiao = true
                      }
                  })
                  this.zhongjiaoTableArray.forEach(function (element) {
                      if(element.value.length > 0){
                        that.hasZhongJiao = true
                      }
                  })
                  this.xiajiaoTableArray.forEach(function (element) {
                      if(element.value.length > 0){
                        that.hasXiaJiao = true
                      }
                  })
                  this.generateTableData()
                  this.startCountDown()
              }else{
                  this.$message({
                      message:(data.msg&&data.msg.length > 0)?data.msg:'出方异常，请联系管理员',
                      type:'error'
                  })
              }
          },(err)=>{
              console.log(err)
          })
        },
        submit(){
          this.prescriptionStyleVisible = true
        },
        generatePrescription(pdfStyle){
          this.prescriptionStyleVisible = false
          sessionStorage.setItem('consultInfo',JSON.stringify(this.consultInfo))
          sessionStorage.setItem('basicTable',JSON.stringify(this.basicTableArray))
          sessionStorage.setItem('shangjiaoTableArray',JSON.stringify(this.shangjiaoTableArray))
          sessionStorage.setItem('zhongjiaoTableArray',JSON.stringify(this.zhongjiaoTableArray))
          sessionStorage.setItem('xiajiaoTableArray',JSON.stringify(this.xiajiaoTableArray))
          sessionStorage.setItem('tablePrescription',JSON.stringify(this.tablePrescription))
          this.$router.push({
            path:'/prescriptionImage',
            query:{
              visitRecordId:this.visitRecordId,
              pdfStyle:pdfStyle,
            }
          })
        },
        serviceInfo(index){
          sessionStorage.setItem('serviceInfo',JSON.stringify({
            patientId:this.consultInfo.patientId,
            useDate:this.consultInfo.useDate,
            useDays:this.consultInfo.useDays,
            serviceIndex:index
          }))
          this.$router.push({
            path:'/serviceResult',
            query:{
              visitRecordId:this.visitRecordId,
            }
          })
        },
        startCountDown(){
          var that = this
          if(this.interval != undefined && this.interval != null){
              clearInterval(this.interval)
          }
          this.interval = setInterval(function () {
            var currentTimeMill = Date.parse(new Date())
            var hasCountDown = false;
            that.tablePrescription.forEach(item => {
              var timeMill = item.checkStartTime
              if(currentTimeMill > timeMill && item.checkStatus != '0'){
                var second = 0;
                if(item.checkStatus == '1'){
                  second = (currentTimeMill - timeMill) / 1000;
                  if(second >= 1){
                    hasCountDown = true;
                  }
                }else{
                  second = (item.checkEndTime - timeMill)/1000;
                }
                if(second >= 1){
                  // 小时位
                  var hr = Math.floor(second / 3600);
                  var hrStr = hr.toString();
                  if (hrStr.length == 1) hrStr = '0' + hrStr;
                  // 分钟位
                  var min = Math.floor((second - hr * 3600) / 60);
                  var minStr = min.toString();
                  if (minStr.length == 1) minStr = '0' + minStr;
                  // 秒位
                  var sec = second - hr * 3600 - min * 60;
                  var secStr = sec.toString();
                  if (secStr.length == 1) secStr = '0' + secStr;
                  item.checkCountDown = hrStr+"小时"+minStr+"分钟"+secStr+"秒"
                  that.$set(item, 'checkCountDown', hrStr+"小时"+minStr+"分钟"+secStr+"秒");
                }else{
                  item.checkCountDown = ""
                }
              }else{
                item.checkCountDown = ""
              }
            })
            if(!hasCountDown){
              clearInterval(that.interval);
            }
            that.$forceUpdate();
          }, 1000);
          // setTimeout(()=>{
          // },2000)
        },
        generateTableData(){
          this.tablePrescription = []
          var hasChecking = false;
          for (var i = 0; i < this.prescriptions.length; i++){
            var table_data_item = {}
            var item = this.prescriptions[i]
            table_data_item.count = item.count
            table_data_item.charge = item.charge
            table_data_item.totalWeight = item.totalWeight
            table_data_item.startDate = item.startDate
            table_data_item.endDate = item.endDate
            table_data_item.title = item.name
            table_data_item.type = item.type
            table_data_item.checkTips = item.checkTips
            table_data_item.checkEnable = item.checkFlag == "Y"
            table_data_item.checkStatus = item.checkStatus
            table_data_item.prescriptionId = item.prescriptionId
            table_data_item.checkOrderId = item.checkOrderId
            table_data_item.checkPrice = item.checkPrice
            table_data_item.payStatus = item.payStatus
            table_data_item.reason = item.reason
            table_data_item.checkImageUrl = item.checkImageUrl
            table_data_item.checkStartTime = item.checkStartTime
            switch(item.checkStatus){
              case '0':
                table_data_item.checkStatusText = "提交互联网医院审核"
                break;
              case '1':
                table_data_item.checkStatusText = "审核中"
                hasChecking = true;
                break;
              case '2':
                table_data_item.checkStatusText = "审核成功"
                break;
              case '3':
                table_data_item.checkStatusText = "审核失败"
                break;
              default:
                table_data_item.checkStatusText = ""
                break;
            }
            if(item.checkStatus == '0'){
              switch(item.payStatus){
                case '0':
                  table_data_item.checkStatusText = "提交互联网医院审核"
                  break;
                case '1':
                  table_data_item.checkStatusText = "支付成功"
                  break;
                case '-6':
                  table_data_item.checkStatusText = "支付失败"
                  break;
                case '99':
                  table_data_item.checkStatusText = "支付中"
                  break;
                default:
                  table_data_item.checkStatusText = "提交互联网医院审核"
                  break;
              }
            }
            table_data_item.modifyFlag = item.modifyFlag
            var itemArray = item.prescription
            for (var j = 0; j < item.prescription.length;j++){
                var itemJ = item.prescription[j]
                if(j%2 == 1){
                    itemArray[j-1].key1 = itemJ.key
                    itemArray[j-1].value1 = itemJ.value
                    itemArray[j-1].index1 = itemJ.index
                    itemArray[j-1].visible1 = false
                }else{
                  itemArray[j].visible = false
                }
            }
            var options = []
            for (var k = 0; k < itemArray.length;k++){
                if(k%2 == 0){
                    options.push(itemArray[k])
                }
            }
            table_data_item.options = options
            this.tablePrescription.push(table_data_item)
            if(hasChecking){
              this.getCheckStatus();
            }
          }
        },
        getCheckStatus(){
          //prescriptionCheck/v1/check/status/{checkOrderId}
          var that = this
          if(this.checkInterval != undefined && this.checkInterval != null){
              clearInterval(this.checkInterval)
          }
          this.checkInterval = setInterval(function () {
            var hasChecking = false;
            that.tablePrescription.forEach((item)=>{
              if(item.checkStatus == '1'){
                hasChecking = true;
                that.wjtHttp.get(that,'/api/prescriptionCheck/v1/check/status/'+item.checkOrderId,{},false,(res)=>{
                        var data = res.data
                        if(data.code == 200){
                          if(data.data.statusCode == '2'||data.data.statusCode =='3'){
                            that.getPrescriptionDetails();
                          }
                        }
                    },(err)=>{
                        console.log(err)
                    })
              }
            })
            if(!hasChecking){
              clearInterval(that.checkInterval);
            }
          },5000);
        },
        drugChangeClick(pane,item,flag){
          this.currentItem = item
          this.currentPane = pane
          this.flag = flag
          var params = {
            patientId:this.patientId,
            visitRecordId:this.visitRecordId,
            medicineName:flag == 0?item.key:item.key1,
            number:parseInt(this.tabActive)+1,
            startDate:pane.startDate,
            endDate:pane.endDate,
            type:pane.type
          }
          this.wjtHttp.post(this,'/api/health/v2/prescription/replace',params,false,(res)=>{
                  var data = res.data
                  if(data.code == 200){
                    if(!this.utils.isEmptyStr(data.data.replaceMedicines)){
                      this.changeDrugList = data.data.replaceMedicines
                      this.currentDrug = ''
                      this.dialogDrugVisible = true
                    }else{
                      this.$message({
                          message:'无可更换药品',
                          type:'info'
                      })
                    }
                  }else{
                      this.$message({
                          message:(data.msg&&data.msg.length > 0)?data.msg:'无可更换药品',
                          type:'error'
                      })
                  }
              },(err)=>{
                  console.log(err)
              })
        },
        getTextColor(status) {
          // 根据状态值返回对应的文本颜色
          switch (status) {
            case '3':
              return 'red';
            case '2':
              return 'green';
            default:
              return 'black';
          }
        },
        dialogConfirm(){
          if(this.utils.isEmptyStr(this.currentDrug)){
            this.$message({
                message:'请选择需要更换的药材',
                type:'info'
            })
            return
          }
          this.dialogDrugVisible = false
          var params = {
            visitRecordId:this.visitRecordId,
            oldMedicineName:this.flag == 0?this.currentItem.key:this.currentItem.key1,
            replaceMedicineName:this.currentDrug,
            oldWeight:this.flag == 0?this.currentItem.value:this.currentItem.value1,
            replaceWeight:this.flag == 0?this.currentItem.value:this.currentItem.value1,
            startDate:this.currentPane.startDate,
            endDate:this.currentPane.endDate,
            type:this.currentPane.type,
            number:parseInt(this.tabActive)+1,
          }
          this.wjtHttp.post(this,'/api/health/v2/prescription/replace/submit',params,false,(res)=>{
                  var data = res.data
                  if(data.code == 200){
                    this.wjtHttp.post(this,'/api/health/v1/prescription',{visitRecordId:this.visitRecordId},false,(res)=>{
                            var data = res.data
                            if(data.code == 200){
                                this.prescriptions = data.data
                                this.generateTableData()
                            }else{
                                this.$message({
                                    message:(data.msg&&data.msg.length > 0)?data.msg:'出方异常，请联系管理员',
                                    type:'error'
                                })
                            }
                        },(err)=>{
                            console.log(err)
                        })
                  }else{
                      this.$message({
                          message:(data.msg&&data.msg.length > 0)?data.msg:'更换药材失败',
                          type:'error'
                      })
                  }
              },(err)=>{
                  console.log(err)
              })
        },
        checkConfirm(pane){
          const regex = /\d/;
          var hasNumbers = regex.test(this.consultInfo.name);
          if(!hasNumbers){
            this.currentPane = pane
            this.checkDialogVisible = true
          }else{
            this.$message({
              message:"患者姓名不能包含数字",
              type:'error'
            })
          }

        },
        check(){
          var pane = this.currentPane
          var params = {
            endDate:pane.endDate,
            prescriptionId:pane.prescriptionId,
            startDate:pane.startDate,
            type:pane.type,
            visitRecordId:this.visitRecordId
          }
          this.wjtHttp.post(this,'/api/prescriptionCheck/v1/order/place',params,true,(res)=>{
                  var data = res.data
                  if(data.code == 200){
                    sessionStorage.setItem('checkPlaceOrderInfo',JSON.stringify(data.data))
                    sessionStorage.setItem('checkActiveName',this.tabActive)
                    this.$router.push('/wjtpayCheck')
                  }else{
                      this.$message({
                          message:(data.msg&&data.msg.length > 0)?data.msg:'审核失败，请联系管理员',
                          type:'error'
                      })
                  }
              },(err)=>{
                  console.log(err)
              })

        },
        drugWeightClick(pane,item,flag){
          this.currentItem = item
          this.currentPane = pane
          this.flag = flag
          this.currentWeight = this.flag == 0?item.value:item.value1
          this.dialogWeightVisible = true
        },
        dialogWeightConfirm(){
          this.dialogWeightVisible = false
          var params = {
            visitRecordId:this.visitRecordId,
            oldMedicineName:this.flag == 0?this.currentItem.key:this.currentItem.key1,
            replaceMedicineName:this.flag == 0?this.currentItem.key:this.currentItem.key1,
            oldWeight:this.flag == 0?this.currentItem.value:this.currentItem.value1,
            replaceWeight:this.currentWeight,
            startDate:this.currentPane.startDate,
            endDate:this.currentPane.endDate,
            type:this.currentPane.type,
            number:parseInt(this.tabActive)+1,
          }
          this.wjtHttp.post(this,'/api/health/v2/prescription/replace/submit',params,false,(res)=>{
                  var data = res.data
                  if(data.code == 200){
                    this.wjtHttp.post(this,'/api/health/v1/prescription',{visitRecordId:this.visitRecordId},false,(res)=>{
                            var data = res.data
                            if(data.code == 200){
                                this.prescriptions = data.data
                                this.generateTableData()
                            }else{
                                this.$message({
                                    message:(data.msg&&data.msg.length > 0)?data.msg:'修改重量异常，请联系管理员',
                                    type:'error'
                                })
                            }
                        },(err)=>{
                            console.log(err)
                        })
                  }else{
                      this.$message({
                          message:(data.msg&&data.msg.length > 0)?data.msg:'修改重量异常，请联系管理员',
                          type:'error'
                      })
                  }
              },(err)=>{
                  console.log(err)
              })
        },
        numberChange(value){
          this.currentItem.newValue = value
        },
        getOtherInfo(type){
          var url = 'api/health/v2/rela/record'
          var params = {
            patientId:this.consultInfo.patientId,
            recordType:type,
            toDoDay: this.consultInfo.useDate,
            relaVisitRecordId: this.visitRecordId,
            takeDays: this.consultInfo.useDays
          }
          this.wjtHttp.post(this,url,params,true,(res)=>{
                  var data = res.data
                  if(data.code == 200){
                      var rs = data.data.split('\n')
                      var newRS = []
                      rs.forEach((val,index)=>{
                        if(val.length != 0){
                          newRS.push(val.replace(/ /g,''))
                        }
                      })
                      if(type == 'T'){
                        this.t_results = newRS
                      }else if(type == 'M'){
                        this.m_results = newRS
                      }else if(type == 'A'){
                        this.a_results = newRS
                      }else if(type == 'C'){
                        this.c_results = newRS
                      }
                  }else{
                      this.$message({
                          message:(data.msg&&data.msg.length > 0)?data.msg:'搜索异常，请联系管理员',
                          type:'error'
                      })
                  }
              },(err)=>{
                  console.log(err)
              })
        }
    },
    destroyed() {
      clearInterval(this.interval)
      clearInterval(this.checkInterval)
    },
    watch:{
      tab_name:function(val){
        if(val == 1 && this.t_results.length == 0){
          this.getOtherInfo('T')
        }if(val == 2 && this.m_results.length == 0){
          this.getOtherInfo('M')
        }if(val == 3 && this.a_results.length == 0){
          this.getOtherInfo('A')
        }if(val == 4 && this.c_results.length == 0){
          this.getOtherInfo('C')
        }
      }
    }
}
</script>

<style scoped>
.prescription-style-tip{
    margin: 0 0 24px;
    text-align: center;
    color: #606266;
    font-size: 16px;
}
.prescription-style-actions{
    display: flex;
    justify-content: center;
    padding-bottom: 12px;
}
>>> .prescription-style-dialog{
    max-width: calc(100% - 32px);
}
.container{
    width: 1160px;
    margin: auto auto;
    display: flex;
    flex-direction: column;
}
.other_info_container{
    width: 1160px;
    margin: auto auto;
    height: auto;
}
.content{
  width: 1100px;
  height: auto;
  background-image: url('../../../static/image/service_background.png');
  background-size: 100% 100%;
  padding: 40px 35px;
  margin: 40px 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: auto;
}
.content>p{
  text-align: left;
  line-height: 26px;
  font-size: 18px;
  margin: 8px 0px;
  color: #126FB3;
}
.container>img{
    width:109px;
    height: 139px;
    margin-top: 60px;
    margin-bottom: 30px;
    margin-left: auto;
    margin-right: auto;
}
.pay-success{
    font-size: 26px;
    color: #3E3A39;
    font-weight: bold;
}
.page-header{
    width: 1160px;
    margin-top: 30px;
    color: #333333;
    font-size: 20px;
}
.page-header >>> div{
    color:#333333;
    font-size: 20px;
}
.area-header-one{
    margin-top: 35px;
}
.basic-info{
    width: 986px;
    margin-top: 30px;
    margin-bottom: 15px;
}
.basic-info>li{
    color: #333333;
    font-size: 18px;
    text-align: left;
    line-height: 40px;
}
.basic-info>li>b{
    font-weight: bold;
}
.table-header{
    background: #156098;
    height: 70px;
    color: white;
}
.table-header>td{
    text-align: center;
    color: white;
    font-weight: bold;
    font-size: 18px;
}
.basic-table{
    margin-left: 35px;
}
.basic-table>td{
    height: 50px;
}
.table-rows>td{
    height: 50px;
    background: white;
    font-size: 18px;
}
.table-button{
  height: 70px;
  width: 986px;
  font-size: 18px;
  background: #f9f9f9;
  text-align: left;
  padding-left: 30px;
}
.table-footer-td{
    height: 70px;
    background: white;
    font-size: 18px;
    background: #f9f9f9;
    text-align: left;
    padding-left: 30px;
}
.table-footer-td>b{
    font-size: 18px;
    color: red;
}
.td-total{
    text-align: center;
    height: 70px;
    background: white;
    font-size: 18px;
}
.td-amount{
    text-align: left;
    height: 70px;
    background: white;
    text-align: left;
    padding-left: 30px;
    font-size: 18px;
}
  .table-rows>td{
      height: 50px;
      background: white;
      font-size: 18px;
  }
.drug-weight{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.img-add-sub{
    width: 34px;
    height: 30px;
    position: relative;
    left: 220px;
}
.btn-confirm{
    width: 384px;
    border-radius: 40px;
    margin-top: 60px;
    margin-bottom: 60px;
    font-size: 18px;
    height: 45px;
    margin-left: auto;
    margin-right: auto;
}
.btn-check{
    width: 200px;
    border-radius: 6px;
    font-size: 18px;
    height: 45px;
    margin-left: auto;
    margin-right: auto;
}
.header-container{
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background: #F7F7F7;
}
.header-container>img{
    width: 171px;
    height: 50px;
}
.title{
    color: white;
    font-size: 20px;
    position: relative;
    right: 150px;
}
.btn-info{
    width: auto;
    height: 40px;
    border-radius: 5px;
    font-size: 18px;
    margin-right: 20px;
    margin-top: 5px;
    margin-bottom: 5px;
}
.tabs{
    width: 100%;
    height: auto;
    margin-top: 20px;
    overflow-y: auto;
}
.item-row-center{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.item-row{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.item-column{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.list-span{
  height: 50px;
  width: 100%;
  color: #333;
  border-style: solid;
  border-color: #e6e6e6;
  border-bottom-width: 0.2px;
  text-align: center;
}
.radio{
  width: 100%;
  margin-bottom: 20px;
  margin-left: 0px;
  margin-right: 0px;
}
.span-index{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 25px;
  height: 25px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
  border-style: solid;
  border-color: red;
  border-width: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/kaifang/Prescription.vue